/**
 * Client status, as the design draws it (B2BClientMaster → `Status`).
 *
 * Active / Draft / Paused, in the design's own colour logic: green for running,
 * gold for not-yet-configured, red for deliberately stopped. Expressed through
 * the shared `Chip` tones rather than raw hexes, so it follows the dashboard
 * theme (Layout Contract rule 1) and dark mode for free.
 *
 * Shared because the clients table and the client detail header must never
 * disagree about what "Paused" looks like.
 */
import { Chip } from './primitives'
import type { B2bClientStatus } from '../../../services/b2bApi'

const TONE: Record<B2bClientStatus, 'success' | 'gold' | 'danger'> = {
  active: 'success',
  draft: 'gold',
  paused: 'danger',
}

const LABEL: Record<B2bClientStatus, string> = {
  active: 'Active',
  draft: 'Draft',
  paused: 'Paused',
}

export default function ClientStatusBadge({ status }: { status: B2bClientStatus }) {
  const tone = TONE[status] ?? 'neutral'

  return (
    <Chip tone={tone}>
      {/* The design pairs every status with a dot of its own colour. */}
      <span
        aria-hidden
        style={{
          width: '6px',
          height: '6px',
          borderRadius: '999px',
          background: 'currentColor',
          display: 'inline-block',
        }}
      />
      {LABEL[status] ?? status}
    </Chip>
  )
}
